<template>
    <div>
        <app-bar :title="t('workout_executions_title')"/>

        <v-app-bar
            color="transparent"
            height="84"
            elevation="0"
            class="mb-n6 px-6"
        >
            <v-toolbar-title>{{ workoutExecution.workout.name }}</v-toolbar-title>
            <v-btn
                :to="{ name: 'workout-executions' }"
                plain
                icon
                absolute
                right
                class="mr-n8"
            ><v-icon>mdi-close</v-icon></v-btn>
        </v-app-bar>

        <v-layout>
            <v-progress-linear
                v-if="overlay"
                absolute
                indeterminate
            ></v-progress-linear>

            <div class="px-10 pb-6 overflow-hidden">
                <workout-execution-view :execution="workoutExecution"></workout-execution-view>
            </div>

        </v-layout>
    </div>
</template>

<script lang="ts">
    import { computed, defineComponent, onMounted, reactive, toRefs, watch } from '@vue/composition-api'
    import { useI18n } from 'vue-i18n-composable'
    import { useStore } from '@/store'
    import { useRouter } from '@/composition-api'
    import { useEnums } from '@/core/defaults'
    import { WorkoutExecution } from '@/core/models/workout-execution'
    import WorkoutExecutionView from '@/components/workout-executions/WorkoutExecutionView.vue'

    export default defineComponent({
        components: {
            WorkoutExecutionView
        },

        /**
         * Component constructor.
         *
         * @param props
         */
        setup(props) {
            const store = useStore()
            const router = useRouter()
            const id = router.currentRoute.params['id']


            const state = reactive({
                overlay: true,
            })

            const capture = () => {
                store.dispatch('workoutExecution/get', { id: id, payload: { relations: 'user,workout,feedback,workout.sets,workout.stroke,workout_set_executions,workout_set_executions.set,workout_set_executions.set.stroke' } }).then(() => {
                    state.overlay = false
                })
            }

            const workoutExecutionModel = computed(() => <WorkoutExecution>store.getters['workoutExecution/get'])

            onMounted(() => {
                capture()
            })

            return {
                capture,
                workoutExecution: workoutExecutionModel.value,
                ...useI18n(),
                ...useEnums(),
                ...toRefs(state)
            }
        }
    })
</script>
